<script>
export default {
    name: "ConstructionPricesTab",
    props: {
        construction: {required: true},
        shows: {required: false, default: []},
    },
    computed: {
        paymentMethods: function () {
            const str = []

            if (this.construction.fgts) {
                str.push('FGTS')
            }

            if (this.construction.capitalization_bond) {
                str.push('Titulo de Capitalização')
            }

            if (this.construction.letter_of_credit) {
                str.push('Carta de Crédito')
            }

            if (this.construction.bank_financing) {
                str.push('Financiamento Bancário')
            }

            if (this.construction.direct_financing) {
                str.push('Financiamento Direto')
            }

            if (this.construction.mcmv) {
                str.push('Minha Casa Minha Vida')
            }

            if (this.construction.exchange) {
                str.push('Permuta')
            }

            return str.join(' - ')
        },
        rentalRequirements: function () {
            const str = []

            if (this.construction.lessor_bail) {
                str.push('Seguro fiança')
            }
            if (this.construction.guarantor) {
                str.push('Fiador')
            }
            if (this.construction.deposit) {
                str.push('Depósito')
            }
            if (this.construction.requires_guarantor_deed) {
                str.push('Escritura do fiador')
            }

            return str.join(' - ')
        }
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light" style="padding-top: 0;padding-bottom:0">
                    <h4 style="margin-top: 0;"><b>Venda</b></h4>
                </div>
                <div class="portlet light-grey">
                    <div class="row">
                        <div class="col-lg-4 col-xs-12">
                            <strong>Valor de venda:</strong>
                            <p>
                                <span v-if="construction.sell_price">{{ construction.sell_price | money }}</span>
                                <span v-else>-</span>
                            </p>
                        </div>
                        <div class="col-lg-4 col-xs-12">
                            <strong>IPTU:</strong>
                            <p>
                                <span v-if="construction.iptu_price">{{ construction.iptu_price | money }}</span>
                                <span v-else>-</span>
                            </p>
                        </div>
                        <div class="col-lg-4 col-xs-12">
                            <strong>Condomínio:</strong>
                            <p>
                                <span v-if="construction.condominium_price">{{ construction.condominium_price | money }}</span>
                                <span v-else>-</span>
                            </p>
                        </div>
                        <div class="col-xs-12">
                            <strong>Aceita: </strong><span v-if="paymentMethods">{{ paymentMethods }}</span> <span> - </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light" style="padding-top: 0;padding-bottom:0">
                    <h4 style="margin-top: 0;"><b>Locação</b></h4>
                </div>
                <div class="portlet light-grey">
                    <div class="row">
                        <div class="col-xs-12">
                            <strong>Valor de locação:</strong>
                            <p>
                                <span v-if="construction.rent_price">{{ construction.rent_price | money }}</span>
                                <span v-else>-</span>
                            </p>
                        </div>
                        <div class="col-xs-12">
                            <strong>Exige: </strong><span v-if="rentalRequirements">{{ rentalRequirements }}</span> <span v-else> - </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light" style="padding-top: 0;padding-bottom:0">
                    <h4><b>Temporada</b></h4>
                </div>
                <div class="portlet light-grey" style="margin-bottom: 15px;">
                    <div class="row">
                        <div class="col-lg-4 col-xs-12">
                            <strong>N° max de pessoas: </strong>
                            <span v-if="construction.vacation_max">{{ construction.vacation_max }}</span>
                            <span v-else>-</span>
                        </div>
                        <div class="col-lg-4 col-xs-12">
                            <strong>Aceita animais: </strong>
                            <span v-if="construction.vacation_pets">Sim</span>
                            <span v-else>-</span>

                        </div>
                        <div class="col-lg-4 col-xs-12">
                            <strong>Garagem: </strong>
                            <span v-if="construction.vacation_parking_lots">{{ construction.vacation_parking_lots }}</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                </div>
                <div class="portlet light" style="max-height: 120px;overflow-y: auto;margin-bottom: 0;padding-bottom: 0">
                    <div class="row">
                        <table class="table table-striped">
                            <thead>
                            <th>Nome</th>
                            <th>Valor</th>
                            <th>Período
                            </th>
                            </thead>
                            <tbody>
                            <tr v-for="vacation in construction.vacations">
                                <td>
                                    <span>{{ vacation.name }}</span>
                                </td>
                                <td>
                                    <span>{{ vacation.price | money }}</span> <span style="font-size: 12px;">({{ vacation.typeInfo.name }})</span>
                                </td>
                                <td>
                                    <span>{{ vacation.initial | date }}</span>
                                    <span v-if="vacation.final"> à {{ vacation.final | date }} </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <date-holder id="property-availabilities-inline" :property='info' readonly="readonly"></date-holder>
            </div>
        </div>
    </div>

</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionPricesTab.vue?3193fb9f